module.exports = __webpack_public_path__ + "assets/images/23c02113b4199a395ec158d1e3e92f38.png";